import {Box, CircularProgress, Skeleton} from "@mui/material";

interface Props {
    isMobile: boolean
}

const LoadingSkeleton: React.FC<Props> = ({isMobile}) => {
    return (
        <Box
            sx={{
                height: "100%",
                width: "100%",
                display: "flex",
                borderTop: "1px solid rgba(0, 0, 0, 0.08)",
                bgcolor: "rgba(249, 250, 252, 0.92)",
            }}
        >
            <Box
                sx={{
                    flex: 1,
                    minWidth: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                }}
            >
                <CircularProgress/>
            </Box>

            {!isMobile && (
                <Box
                    sx={{
                        width: 340,
                        minWidth: 340,
                        flexShrink: 0,
                        borderLeft: "1px solid",
                        borderColor: "rgba(0, 0, 0, 0.08)",
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                        bgcolor: '#fff',
                    }}
                >
                    <Box sx={{p: 2}}>
                        <Skeleton variant="text" width="60%" height={32}
                                  sx={{mb: 2}}/>
                        <Skeleton variant="rounded" height={80} sx={{mb: 1}}/>
                        <Skeleton variant="rounded" height={80} sx={{mb: 1}}/>
                        <Skeleton variant="rounded" height={80}/>
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default LoadingSkeleton;
